import React from 'react';
import Section from '../components/Section';
import ChipSelect from '../components/ChipSelect';
import TextField from '../components/TextField';

const STAFF_OPTIONS = [
  'No issues',
  'Late arrival',
  'No-show or absent',
  'Conflict or behaviour issue',
  'Short-staffed all shift',
  'New staff needed more support',
];

function S6_Staff({ data, onChange }) {
  // staff_issues is now text[] — ensure it is always an array
  const selected = Array.isArray(data.staff_issues) ? data.staff_issues : [];

  return (
    <Section title="Staff">
      <ChipSelect
        label="Any staff issues today?"
        options={STAFF_OPTIONS}
        selected={selected}
        onChange={(v) => onChange('staff_issues', v)}
      />

      <TextField
        label="Any details?"
        value={data.staff_notes || ''}
        onChange={(v) => onChange('staff_notes', v)}
        multiline
        maxLength={200}
        placeholder="Optional — add any details here"
      />
    </Section>
  );
}

export default S6_Staff;
